import React, { useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import classes from './styles.module.scss';

export function ImageModal({ src, onClose }) {
    const { t } = useTranslation('carReport', { keyPrefix: 'internalReport' });

    useEffect(() => {
        const handleEsc = e => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    return (
        <div className={classes.modalOverlay} onClick={onClose}>
            <div className={classes.modalContent} onClick={e => e.stopPropagation()}>
                <button className={classes.modalCloseBtn} onClick={onClose} aria-label="Close">
                    <CloseOutlined />
                </button>
                <div className={classes.imageContainer}>
                    <img
                        src={src}
                        alt={t('modal.imageAlt')}
                        className={classes.modalImage}
                        onDragStart={e => e.preventDefault()}
                    />
                </div>
            </div>
        </div>
    );
}
